import { set_class } from '@vaaas/fpts/dom';
import { reactive } from 'vue';

export function update_viewport_dimensions() {
    viewport_dimensions.height = window.innerHeight;
    viewport_dimensions.width = window.innerWidth;
    manipulate_body_classes();
}

export function manipulate_body_classes(elem = document.documentElement) {
    set_class(elem, 'tiny-height', tiny_height());
    set_class(elem, 'small-height', small_height());
    set_class(elem, 'medium-height', medium_height());
    set_class(elem, 'large-height', large_height());

    set_class(elem, 'tiny-width', tiny_width());
    set_class(elem, 'small-width', small_width());
    set_class(elem, 'medium-width', medium_width());
    set_class(elem, 'large-width', large_width());
}

export const viewport_dimensions = reactive({
    height: globalThis.innerHeight ?? 0,
    width: globalThis.innerWidth ?? 0,
});

export const tiny_height = () => viewport_dimensions.height <= 1024*0.75*0.75;
export const small_height = () => viewport_dimensions.height <= 1024*0.75;
export const medium_height = () => viewport_dimensions.height <= 1024;
export const large_height = () => viewport_dimensions.height > 1024;

export const tiny_width = () => viewport_dimensions.width <= 1024*0.75*0.75;
export const small_width = () => viewport_dimensions.width <= 1024*0.75;
export const medium_width = () => viewport_dimensions.width <= 1024;
export const large_width = () => viewport_dimensions.width > 1024;
